import { css } from "@stubhub/broadway-foundation/css";

export const styledBody = css({
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: "auto",
});

export const styledFooter = css({
  flexShrink: 0,
});
